/**
 * Fullscreen functionality pollyfill.
 * It is supported in Safari browser only with 'webkit' prefix. (by 2022)
 */

/**
 * Element.requestFullscreen() polyfill
 */
if (!Element.prototype.requestFullscreen) {
    Element.prototype.requestFullscreen = Element.prototype.webkitRequestFullscreen;
}

/**
 * document.exitFullScreen() polyfill
 */
if (!document.exitFullscreen) {
    document.exitFullscreen = document.webkitExitFullscreen;
}

/**
 * document.fullscreenElement polyfill
 */
if (!document.fullscreenElement) {
    Object.defineProperty(document, 'fullscreenElement', {
        get: function() {
            return document.webkitFullscreenElement;
        }
    });
    Object.defineProperty(document, 'fullscreenEnabled', {
        get: function() {
            return document.webkitFullscreenEnabled;
        }
    });
}
